/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {startLoadding, stopLoading} from '../../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {GetSavedCampaigsList} from '../../../new-message/BulkMessageSlice/BulkMessageSlice'
import {toast} from 'react-toastify'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState = {
  ourTemplates: [],
  categoryList: [],
}

export const getOurTemplate: any = createAsyncThunk(
  'quickSms/getOurTemplate',
  async (data, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.get(`${API_URL}admintemplate/ourtemplate`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const DeleteDraftCampaign: any = createAsyncThunk(
  'DeleteDraftCampaign',
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.delete(`${API_URL}draftcampaign/campaign/${data.id}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    response.data.status == true && toast.success('Draft-Campaign deleted successfully')
    thunkApi.dispatch(GetSavedCampaigsList())
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const GetAllCategory: any = createAsyncThunk('GetAllCategory', async (data, thunkApi) => {
  const response = await axios.get(`${API_URL}admintemplate/uniquecategory`, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  return response.data
})
const OurTemplateSlice = createSlice({
  name: 'OurTemplateSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getOurTemplate.fulfilled, (state, action) => {
      return {...state, ourTemplates: action?.payload}
    })
    builder.addCase(GetAllCategory.fulfilled, (state, action) => {
      return {...state, categoryList: action?.payload}
    })
  },
})

export const getOurTemplateList = (state: any) => state?.ourTemplate?.ourTemplates?.data
export const getAllCategoryList = (state: any) => state?.ourTemplate?.categoryList

export default OurTemplateSlice.reducer
